<template>
  <k-autocomplete
    :items="items"
    v-model="val"
    :label="label || title"
    item-text="name"
    item-value="id"
    :loading="loading"
    :search-input.sync="search"
    hide-no-data
    hide-details
    :clearable="clearable"
  ></k-autocomplete>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';
import Vue from 'vue';

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'label',
    'title',
    'name',
    'settings',
    'content_id',
    'clearable'
  ],
  data () {
    return {
      loading: false,
      items: [],
      search: null
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    }
  },
  methods: {
    querySelections(val) {
      if(val.length < 3 || _.isEmpty(this.apikey)) {
        this.items = []

        return
      }

      if(this.content_id == "series") {
        this.loading = true
        let api_url = "https://opal.nm-ovp.nelonenmedia.fi/v1/series?apiKey=" + this.apikey + "&filter[search]=" + val

        // Use Fetch API instead of Vue.http.get() because Vue HTTP client contains default Authorization headers for internal use
        fetch(api_url)
          .then((response) => {
            // Technical processing
            if(!response.ok) { throw response.status }

            return response.json()
          })
          .then((content) => {
            // Content processing
            let response_data = _.get(content, "data", [])

            this.items = _.map(
              response_data,
              (serie) => {
                return {
                  id: serie.id,
                  name: _.get(serie, "attributes.display_name", "")
                }
              }
            )

            this.loading = false
          })
          .catch((error) => {
            console.error("Sanoma API fetch failed", error)

            this.loading = false
          })
      }
    }
  },
  computed: {
    apikey () {
      return _.get(this.settings, "apikey");
    },
    val: {
      get () {
        return _.get(this.value, this.name);
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
